import { Button, Card, Checkbox, Divider, Form, Input, message, Modal, Select, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { UserEventService } from "../../../../api/user.service";
import { UserLogEventService } from "../../../../api/user-log.service";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { useParams } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { useForm } from "antd/es/form/Form";
import { MasterDataEventService } from "../../../../api/master-data-event.service";
import { ClockCircleOutlined, LockOutlined } from "@ant-design/icons";
import { AgendesService } from "../../services/agendes-service";
import { loadAppConfig } from "../../../../configs/app-config";
import { AgendaUrlService } from "../../../../api/agenda.service";

const CheckboxGroup = Checkbox.Group;

type AgendaDto = {
  agendaId: string;
  room: string;
  detail: AgendaDetailDto[];
};

type AgendaDetailDto = {
  key: string;
  schedule: string;
  content: string;
};

export const EconnectStepWristband: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, wristbandid } = useParams<{ agendaid: string; wristbandid: string }>();
  const [form] = useForm();
  const [formPassword] = useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const [agenda, setAgenda] = useState<any>([]);
  const [userData, setUserDate] = useState<{
    userId: "";
    numberId: string;
    dataSource: {
      fullname: string;
      position: string;
      company: string;
      businessEmail: string;
      phoneNumber: string;
      businessType: {
        value: string;
        label: string;
      };
      type: string;
      ticketNumber: string;
    };
  } | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [roomAction, setRoomAction] = useState<any | null>(null);
  const [masterDataEvent, setMasterDataEvent] = useState<{ value: string; label: string }[]>([]);
  const [checkedList, setCheckedList] = useState<string[]>([]);
  const mockDataAgenda = [
    {
      agendaId: "1",
      room: "Energise I",
      detail: [
        { key: "1", schedule: "13:30 – 14:00 pm", content: "Panel: Sustainable" },
        { key: "2", schedule: "16:00 – 17:00 pm", content: "Panel: ATOM" },
        { key: "3", schedule: "16:00 – 17:00 pm", content: "Panel: State of speed tooling" },
      ],
    },
    {
      agendaId: "2",
      room: "Energise II",
      detail: [
        { key: "1", schedule: "13:30 – 14:00 pm", content: "CX (Dev)" },
        { key: "2", schedule: "14:00 – 15:00 pm", content: "Customer Experience" },
        { key: "3", schedule: "15:00 – 16:00 pm", content: "Panel: Cloud Migration" },
      ],
    },
    {
      agendaId: "3",
      room: "Radiant – Junior Ballroom",
      detail: [
        { key: "1", schedule: "18:00 – 19:00 pm", content: "Opening: The new era of Orchestra" },
        { key: "2", schedule: "19:00 – 20:00 pm", content: "The Highlight show" },
        { key: "3", schedule: "20:00 – 22:00 pm", content: "After party" },
      ],
    },
  ];

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid && wristbandid) {
        const resMasterDataEvent = await MasterDataEventService(apiBaseUrl).getByEventId(agendaid);
        setMasterDataEvent(resMasterDataEvent.dataSource);
        const user = await UserEventService(apiBaseUrl).getByEventAndWristbandid(agendaid, wristbandid);
        const agenda = await AgendaUrlService(apiBaseUrl).getOne(agendaid);
        if (agenda.length > 0) {
          setAgenda(agenda);
        }
        form.setFieldsValue({
          fullName: user.dataSource.fullname,
          position: user.dataSource.position,
          company: user.dataSource.company.label,
          businessType: user.dataSource.businessType.value,
          businessEmail: user.dataSource.businessEmail,
          phoneNumber: user.dataSource.phoneNumber,
          wristbandId: user.dataSource.wristbandId,
        });
        setUserDate(user);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onSetWristband = async (event: any) => {
    if (!userData) return console.error("User Data fail!!");
    if (roomAction === null) return console.error("RoomAction Data fail!!");
    // console.log(agenda);
    const data = {
      userId: userData.userId,
      action: roomAction.value,
      actionDetail: {
        fullName: userData?.dataSource.fullname,
        position: userData?.dataSource.position,
        company: userData?.dataSource.company,
        event: agendaid,
        wristbandId: wristbandid,
        actionDetail: roomAction,
      },
    };
    try {
      if (wristbandid) {
        await UserLogEventService(apiBaseUrl).create(data);
        message.success("success");
        setLoading(true);
        setIsModalOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onChange = (list: string[]) => {
    setCheckedList(list);
  };

  const onValidatePassword = async (password: string): Promise<string | undefined> =>
    agendaid && AgendesService(apiBaseUrl).validatePassword(agendaid, password);

  return userData === null ? (
    <Spin tip="Loading..." spinning={loading}>
      <Card>ไม่มีผู้ใช้งาน "Ristband ID" {wristbandid} นี้</Card>
    </Spin>
  ) : (
    <Spin tip="Loading..." spinning={loading}>
      <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px]">
        <div className=" flex justify-center">
          <Title level={4}>Ristband ID: {wristbandid}</Title>
        </div>
        <br />
        <Form form={form} layout="vertical" autoComplete="off" className="w-full">
          <Card>
            <Form.Item className=" m-1" label={`เช็คอินเข้าห้องประชุม`}>
              {agenda[0].agendaDetail.map((item: any, index: number) => {
                return (
                  <>
                    <div
                      className="flex justify-between items-center  pb-2 rounded-lg text-gray-800 font-semibold"
                      // style={{
                      //   background: "linear-gradient(to right, #B2E0F6, #E4C6CB)",
                      //   borderRadius: "0px",
                      // }}
                    >
                      <div className="flex items-center gap-2">
                        <ClockCircleOutlined className="text-gray-600" />
                        <span> {item.label}</span>
                        <br />
                      </div>
                    </div>
                    {item.children.map((session: any) => (
                      <div key={`${item.key}-${session.value}`} className=" pb-2">
                        <Button
                          size="small"
                          type="primary"
                          onClick={() => {
                            setIsModalOpen(true);
                            setRoomAction(session);
                          }}
                        >
                          {session.label}
                        </Button>
                      </div>
                    ))}
                  </>
                );
              })}
            </Form.Item>
          </Card>
          <Card>
            <Form.Item className=" m-1" label={"Name-Surname"} name={"fullName"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Position"} name={"position"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Company"} name={"company"}>
              <Input placeholder="Text" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Business Type"} name={"businessType"}>
              <Select placeholder="Select" options={masterDataEvent} disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Business Email"} name={"businessEmail"}>
              <Input placeholder="example@email.com" type="email" disabled />
            </Form.Item>
            <Form.Item className=" m-1" label={"Phone number"} name={"phoneNumber"}>
              <Input placeholder="0XX-XXX-XXXX" disabled />
            </Form.Item>
          </Card>
        </Form>
        <Modal open={isModalOpen} footer={[]} onCancel={() => setIsModalOpen(false)}>
          <Form form={formPassword} name="horizontal_login" layout="inline" onFinish={onSetWristband}>
            {/* <Title level={5}>ห้อง : {roomAction?.room}</Title> */}
            {/* <CheckboxGroup
              className=" pt-2 pb-2"
              options={roomAction?.detail.map((item: AgendaDetailDto) => ({ label: `${item.schedule} ${item.content}`, value: item.key }))}
              value={checkedList}
              onChange={onChange}
            /> */}
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
                {
                  validator: async (_, value) => {
                    if (value) {
                      const validationFailReason = await onValidatePassword(value);
                      if (validationFailReason) {
                        throw new Error(validationFailReason);
                      }
                    }
                  },
                },
              ]}
            >
              <Input prefix={<LockOutlined />} type="password" placeholder="Password" />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Confrim
            </Button>
          </Form>
        </Modal>
      </div>
    </Spin>
  );
};
